export default {
  skip_to_main_content: 'Skip to main content',
  show_system_messages: 'Show system messages',
  dont_show_system_messages: 'Hide system messages',
  logged_in: 'Tenant is authenticated',
  logged_out: 'Anonymous user',
  button_tooltip_switch_locale: 'Switch locale',
  button_tooltip_activate_voice_recognition: 'Activate voice recognition',
  date_input: 'Select date',
  choose_two_dates: 'Please select two dates',
  date_range: 'Date range',
  from: 'from',
  to: 'to',
  avatar: 'Avatar',
  exit: 'Exit',
  new: 'New',
  back: 'Back',
  address: 'Address',
  suggestions: 'Suggestions',
  senton: 'Sent on',
  message_placeholder: 'Enter your message here...',
  message_aria: 'Enter your message here',
  upload_in_progress: 'Upload in progress...',
  comment_placeholder: 'Enter comment here',
  message_button_label: 'Send',
  please_confirm: 'Please confirm',
  no: 'No',
  yes: 'Yes',
  modal_delete_session: 'Delete session',
  modal_delete_session_notification:
    'If you close the window, your session will also be deleted.<br>Are you okay with that?',
  template_contact_time: 'When can we contact you?',
  template_pause:
    'Your session has been paused. One of our support staff will take care of your request shortly.',
  template_continue_after_pause:
    'Your session has continued. You can now continue writing with our chatbot.',
  choose_date: 'Please select a date',

  button_apply: 'Apply',
  button_cancel: 'Cancel',
  none: 'None',
  book_appointment: 'Book Appointment',
  address_input: 'Address input',
  data_processing: 'Data processing',
  privacy_policy: 'privacy policy',
  data_processing_notification_before_link:
    'To use this chat service it is necessary that you accept the ',
  data_processing_notification_after_link: '.',
  button_accept: 'Accept',
  select_date: 'Select Date',
  rate_conversation: 'How would you rate this conversation?',
  new_ticket_question: 'Is there anything else I can help you with?',
  thank_you:
    'Thank you for your support. Your feedback helps me to constantly improve myself.',
  goodbye: 'Goodbye.',
  start_new: 'Start new conversation',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'More',
  collapse_quickreplies: 'Less',
  login: 'Log in',
  logout: 'Log out',
  close: 'Close',
  messenger_text:
    'You can either write with our chatbot or contact one of our employees directly in our live chat.',
  chat_bot: 'Chat Bot',
  live_bot: 'Live Chat',
  maximize: 'Maximize',
  minimize: 'Minimize',
  upload_file: 'Drop file here to upload',
  upload_file_or: 'or',
  Upload_file_select: 'Add files',
  upload_file_text: 'Drop file to upload',
  show_attachments: 'Show attachment',
  hide_attachments: 'Hide attachment',
  tooBig: 'The file is too large',
  tooSmall: 'The file is too small',
  invalidFileTypeCopilot:
    'Invalid file type. Currently only file types .png, .jpg, .jpeg, .gif are supported.',
  tooManyFiles: 'Please upload a maximum of 5 files at once',
  chatProtocol: 'ChatProtocol',
  showMore: 'Show more',
  showLess: 'Show less',
  uploadTooltip: 'Upload file',
  uploadFilesTooltip: 'Upload files',
  pdfDownloadTooltip: 'Download Conversation',
  feedbackDescription: 'Feedback',
  feedbackSubtitle: {
    description:
      'Here you can send us general suggestions, proposals and requests.',
    note: 'Please note that we cannot respond to them.',
    hint:
      'All other concerns that specifically relate to your tenancy or the search for an apartment can be described to us in the chat.'
  },
  feedbackPlaceholder: 'Enter your message here...',
  feedbackInfoPlaceholder: 'Feel free to add specific details here...',
  sendFeedback: 'submit',
  giveFeedback: 'Feedback',
  feedbackSubmittedSuccessfully: 'Your feedback was successfully submitted',
  character_limit: 'Characters',
  page: 'p.',
  factually_incorrect: 'Not factually correct',
  not_following_instructions: "Didn't fully follow instructions",
  info_not_in_document: 'Info not found in document',
  inappropriate_or_offensive: 'Inappropriate or offensive',
  irrelevant: 'Irrelevant',
  not_fitting_topic: 'Not fitting to topic',
  confusing_information: 'Confusing information',
  ignored_important_parts_of_document: 'Ignored important parts of document',
  interpreted_document_wrong: 'Document interpreted incorrectly',
  answer_to_generic: 'Answer too generic',
  sources_incorrect: 'Sources unreliable or incorrectly cited',
  why_not_helpful: 'Why was this not helpful?',
  thank_you_feedback: 'Thank you for your feedback!',
  provide_feedback: 'Provide feedback to this answer',
  not_helpful: 'Not helpful',
  helpful: 'Helpful',
  regenerate_message: 'Regenerate',
  copy_message: 'Copy',
  copied_message: 'Copied!',
  original_answer: 'Original answer',
  regenerated_answer: 'Regenerated answer',
  thinking_message: "I'm thinking...",
  file_path: 'File path: ',
  new_messages: 'New messages',
  previous_message: 'Previous message',
  next_message: 'Next message',
  clear_input: 'Clear input',
  open_feedback: 'Open feedback',
  file_upload: 'File upload',
  expand_quickreplies_aria: 'Show more buttons',
  button_tooltip_switch_locale_german: 'Switch language to German',
  button_tooltip_switch_locale_french: 'Switch language to French',
  button_tooltip_switch_locale_dutch: 'Switch language to Dutch',
  button_tooltip_switch_locale_turkish: 'Switch language to Turkish',
  button_tooltip_switch_locale_russian: 'Switch language to Russian',
  button_tooltip_switch_locale_swedish: 'Switch language to Swedish',
  button_tooltip_switch_locale_ukranian: 'Switch language to Ukrainian',
  button_tooltip_switch_locale_spanish: 'Switch language to Spanish',
  button_tooltip_switch_locale_polish: 'Switch language to Polish',
  button_tooltip_switch_locale_arabic: 'Switch language to Arabic',
  button_tooltip_switch_locale_italian: 'Switch language to Italian',
  button_tooltip_switch_locale_english: 'Switch language to English',
  message_from_you: 'You say',
  message_from_bot: 'Bot says',
  message_from_operator: 'Agent says',
  new_message_from_bot: 'Bot says',
  empty_message_received: 'Empty message received',
  chat_messages: 'Chat messages'
}
